module.exports = __webpack_public_path__ + "static/media/group-pic.52849e73.jpg";